import React, { Component } from "react";
import { Link } from "react-router-dom";
export default class Footer extends Component {
  render() {
    return (
      // Footer Section Begin
      <footer className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="fs-about">
                <div className="fa-logo">
                  <a href="/">
                    <img
                      style={{ height: "96px", width: "245px" }}
                      src="img/logomobile.png"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-3">
              <div className="fs-about">
                <p>
                  Nagesh Murthy, a seasoned photographer and Associate Director
                  at NielsenIQ, captures the beauty of nature and the essence of
                  human spirit through his lens.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-3">
              <div className="fs-widget">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/clicks">Clicks</a>
                  </li>
                </ul>
                <ul>
                  <li>
                    <a href="/blogs">Blogs</a>
                  </li>
                  <li>
                    <a href="/policy">Policy</a>
                  </li>
                  <li>
                    <a href="/contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3">
              <div className="fs-about">
                <div className="fa-social">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/share/1AtqdG3v43/?mibextid=LQQJ4d"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>

                  <a
                    target="_blank"
                    href="https://www.youtube.com/@nageshamurthy4466"
                  >
                    <i className="fa fa-youtube-play"></i>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/nageshmurthyclicks/profilecard/?igsh=MXUwdTBzMnJsNmUwbg=="
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </div>
                <p style={{ marginTop: "12px" }}>
                  <strong>Phone:</strong> +91 9880188455
                </p>
                <p>
                  <strong>Email:</strong> rohinag2@gmail.com
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="copyright-text">
                <p>
                  {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                  Copyright &copy;
                  <script>document.write(new Date().getFullYear());</script> All
                  rights reserved | 2024© Design & Develop by &nbsp;
                  <a
                    href="https://c2m-edutech.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b>C2M Edutech Solutions Ltd</b>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      // Footer Section End
    );
  }
}
